import React, { lazy, useState } from "react";
import { useLocation } from "react-router-dom";

// Libraries
import { Link } from "react-router-dom";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { m } from "framer-motion";

// Components
import { fadeIn, zoomIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";
import InteractiveBanners02 from "../../Components/InteractiveBanners/InteractiveBanners02";
import Clients from "../../Components/Clients/Clients";
import Piechart from "../../Components/PieChart/Piechart";
import Testimonials from "../../Components/Testimonials/Testimonials";
import Tab01 from "../../Components/Tab/Tab01";
import Counter from "../../Components/Counters/Counter";
import BlogClassic from "../../Components/Blogs/BlogClassic";
import SocialIcons from "../../Components/SocialIcon/SocialIcons";
import CustomModal from "../../Components/CustomModal";
import Header, {
  HeaderLanguage,
  HeaderNav,
  Menu,
  SearchBar,
  Topbar,
} from "../../Components/Header/Header";
import FooterMenu, { Footer } from "../../Components/Footers/Footer";
import SideButtons from "../../Components/SideButtons";

// Data
import { InteractiveBannersData02 } from "../../Components/InteractiveBanners/InteractiveBannersData";
import { TabData01 } from "../../Components/Tab/TabData";
import { IconWithTextData_02 } from "../../Components/IconWithText/IconWithTextData";
import { TestimonialsData03 } from "../../Components/Testimonials/TestimonialsData";
import FooterData from "../../Components/Footers/FooterData";
import { blogData } from "../../Components/Blogs/BlogData";

//Scss
import "../../Assets/scss/default.scss";

const IconWithText = lazy(() =>
  import("../../Components/IconWithText/IconWithText")
);

const SwiperData = [
  {
    img: "/assets/img/webp/IMT_DC.jpg",
    title: "Giải pháp tin cậy cho những vấn đề phức tạp",
    subtitle: "Viễn thông, Giám sát An Ninh, Giao Thông",
  },
  {
    img: "/assets/img/webp/IMT_CC.webp",
    title: "Thiết kế giải pháp Giám sát an ninh diện rộng",
    subtitle: "Quy mô giám sát trên địa bàn huyện, thành phố, toàn quốc.",
  },
  {
    img: "/assets/img/webp/TMC.jpg",
    title: "Thiết kế giải pháp Giao thông thông minh (ITS)",
    subtitle: "Tối ưu điều hành giao thông theo chuẩn quốc gia & quốc tế",
  },
];

const HomeBusinessPageData = {
  img: "/assets/img/webp/TMC.jpg",
  content:
    "Established in 2017. We are a leading technology company in Vietnam with years of experience delivering innovative and high-performance technology solutions. We specialize in wide-area security surveillance, intelligent traffic systems, data analytics, and system architecture design.",
  title: "inMeeting JSC.,",
};

const ServiceData = {
  img: "/assets/img/webp/IMT_CC.webp",
  title: "Comprehensive Smart City Solutions:",
};

const ServiceLifecycle = [
  "Consultancy",
  "Design",
  "Development",
  "Implementation",
  "Upgrade",
  "Maintenance & Support",
];

const ContactData = [
  {
    title: "Business Inquiries",
    email: "sales@inmeeting.com.vn",
    phone: "+84 24 7300 7966",
    icon: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75",
  },
  {
    title: "Technical Support",
    email: "support@inmeeting.com.vn",
    phone: "+84 24 7300 7966",
    icon: "M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z",
  },
  {
    title: "Other Inquiries",
    email: "info@inmeeting.com.vn",
    phone: "+84 24 7300 7966",
    icon: "M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z",
  },
];

const SocialIconsData = [
  {
    color: "#0038e3",
    link: "https://www.facebook.com/",
    icon: "fab fa-facebook-f",
  },
  {
    color: "#0038e3",
    link: "https://dribbble.com/",
    icon: "fab fa-dribbble",
  },
  {
    color: "#0038e3",
    link: "https://twitter.com/",
    icon: "fab fa-twitter",
  },
  {
    color: "#0038e3",
    link: "https://www.instagram.com/",
    icon: "fab fa-instagram",
  },
];

const IconWithTextData = [
  {
    icon: "line-icon-Monitoring text-[#b7b7b7] text-[40px]",
    title: "Giải pháp giám sát an ninh diện rộng",
    content:
      "Hệ thống giám sát an ninh là một phần cốt yếu của của cuộc sống hiện đại trong các đô thị. Từ những hệ thống giám sát truy nhập access control, cảm biến và alarm panel đến sự hiện diện của CCTV mọi chỗ mọi nơi, tất cả đều được giám sát và xử lý bởi hệ thống trung tâm Bricks của InMeeting. Chúng tôi có khả năng tư vấn, thiết kế, tích hợp, sản xuất và lắp đặt các hệ thống an ninh cho một trường đại học, một phường, huyện, đến địa bàn một Tỉnh/Thành;  hay cả mạng giám sát an ninh cho một ngân hàng với chi nhánh trải rộng trên Toàn quốc. Chúng tôi am hiểu việc xây dựng hạ tầng CCTV, từ sử dụng mạng Metro cho địa bàn một địa phương, đến mạng SDWAN an ninh chạy trên địa bàn Toàn quốc. Chúng tôi am hiểu xây dựng mạng thu thập, lưu trữ, phân phối dữ liệu video CCTV, tối ưu nhất với hạ tầng mạng và nhu cầu sử dụng, cũng như chi phí lưu trữ $cents/GB phù hợp nhất. Chúng tôi quen thuộc với các kỹ thuật phân tích AI, cho các môi trường an ninh, nhận dạng, giao thông, giải quyết các bài toán an ninh của địa phương, doanh nghiệp. Trong lĩnh vực thiết kế, thi công hệ thống giám sát an ninh, cùng với các đối tác, chúng tôi là chuyên gia tin cậy.  .",
  },
  {
    icon: "line-icon-traffic-Light text-[#b7b7b7] text-[40px]",
    title: "Giải pháp giao thông thông minh (ITS)",
    content:
      "Hệ thống ITS là hệ thống công cụ đa lĩnh vực (Sensors, Communications, Data Processing) nhằm cung cấp khả năng quản lý và điều hành các tuyến giao thông, từ cao tốc huyết mạch đến các mạng lưới giao thông đô thị bận rộn. Với đội ngũ chuyên gia trong nước và quốc tế, chúng tôi sẵn sàng hỗ trợ từ khâu lập báo cáo cơ sở, thiết kế kỹ thuật, bảo vệ dự toán, và thi công các dự án ITS trong nước. Tích hợp và tối ưu các thành phần ITS tiêu chuẩn: ramp meter, CCTV, traffic analytics, WIM, traffic controller đến các trung tâm điều hành TMC trong data center theo hướng dẫn và qui chuẩn EU/Bắc Mỹ/ISO, đảm bảo chi phí đầu tư, khả năng vận hành, chi phí bảo trì trong suốt vòng đời dịch vụ là tối ưu nhất cho người đầu tư và vận hành hệ thống. Cam kết đồng hành cùng đội ngũ vận hành giao thông, chúng tôi cũng cung cấp dịch vụ tối ưu điều hành giao thông, viết và cập nhật các qui trình vận hành tuyến (concept of operations) để đảm bảo khai thác tối đa hạ tầng giao thông hiện có.",
  },
  {
    /*{
    icon: "line-icon-Talk-Man text-[#b7b7b7] text-[40px]",
    title: "Customer satisfaction",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor.",
  },
  {
    icon: "line-icon-Cursor-Click2 text-[#b7b7b7] text-[40px]",
    title: "No coding required",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor.",
  },*/
  },
];

const CounterData = [
  {
    number: {
      text: "2500",
    },
    content: "WORKING HOURS",
  },
  {
    number: {
      text: "3250",
    },
    content: "PHOTO CAPTURE",
  },
  {
    number: {
      text: "2800",
    },
    content: "WORK COMPLETED",
  },
  {
    number: {
      text: "2750",
    },
    content: "TELEPHONIC TALK",
  },
];

// Filter the blog data category wise
const blogClassicdData = blogData
  .filter((item) => item.blogType === "classic")
  .filter((item) => item.category.includes("business"));

const useScrollToLocation = () => {
  const { hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
};

const SectionHeading = ({ title, subtitle, id, compact }) => (
  <div
    id={id}
    className="relative flex flex-col items-center justify-center text-center text-white font-serif"
    style={{
      minHeight: compact ? "90px" : "130px",
      padding: "22px 15px",
      backgroundImage: "linear-gradient(to right,#71bdea 0,#775ea5 100%)",
    }}
  >
    <h2
      className="font-semibold uppercase mb-0"
      style={{
        fontSize: compact ? "26px" : "34px",
        letterSpacing: "3px",
        lineHeight: 1.2,
      }}
    >
      {title}
    </h2>
    {subtitle && (
      <p
        className="mb-0 font-light"
        style={{
          opacity: 0.9,
          maxWidth: "640px",
          letterSpacing: "0.5px",
          marginTop: "10px",
        }}
      >
        {subtitle}
      </p>
    )}
  </div>
);

const HomeBusinessPage = (props) => {
  const [activeKey, setActiveKey] = useState("traffic-control");
  const [menuOpen, setMenuOpen] = useState(false);
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleMouseEnter = () => {
    const serviceProductMenu = document.getElementById("service-product-menu");
    if (serviceProductMenu) {
      serviceProductMenu.classList.toggle("active");
    }
  };

  const handleMouseLeave = () => {
    const serviceProductMenu = document.getElementById("service-product-menu");
    if (serviceProductMenu) {
      serviceProductMenu.classList.remove("active");
    }
  };

  const handleClickService = (id) => {
    setActiveKey(id);
    handleScroll("products");
  };

  const toggleMenu = () => setMenuOpen((open) => !open);

  const handleMobileNav = (id) => {
    setMenuOpen(false);
    handleScroll(id);
  };

  return (
    <div style={props.style}>
      {/* <SideButtons /> */}

      {/* Header Start */}
      <Header
        className="header-with-topbar"
        topSpace={{ desktop: true }}
        type="reverse-scroll"
      >
        {/* <Topbar className="bg-lightgray border-b home-business-topbar border-[#0000001a] sm:hidden md:px-0 header-with-topbar border-bottom px-[35px]">
          <Container fluid>
            <Row className="justify-between pl-[15px] lg:pr-[15px] items-center">
              <Col className="col-12 text-center sm:text-start col-sm-auto me-auto ps-lg-0">
                <SocialIcons theme="social-icon-style-01" size="xs" iconColor="dark" data={SocialIconsData} />
              </Col>
              <Col className="col-auto none sm:block text-end lg:px-0">
                <span className="top-bar-contact-list border-l border-inherit	py-[9px] px-[18px] text-[13px] inline-block float-left">
                  <i className="feather-phone-call text-darkgray mr-[6px] text-md relative top-[1px]"></i>  +84 24 7300 7966
                </span>
                <span className="border-l border-inherit py-[9px] pl-[18px] text-[13px] inline-block float-left border-r-0 pr-0">
                  <i className="feather-map-pin text-darkgray mr-[6px] text-md relative top-[1px]"></i> Tầng 3, số 7A Mạc Thị Bưởi, TP.Hà Nội.
                </span>
              </Col>
            </Row>
          </Container>
        </Topbar> */}
        <HeaderNav
          fluid="fluid"
          theme="light"
          bg="white"
          menu="light"
          className="px-[35px] py-[0px] md:px-[15px] sm:px-0 border-b border-[#0000000f]"
          containerClass="md:px-0"
        >
          <Col className="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
            <Link aria-label="header logo" className="flex items-center" to="/">
              <Navbar.Brand className="inline-block p-0 m-0">
                <img
                  className="default-logo"
                  width="111"
                  height="108"
                  loading="lazy"
                  src="/assets/img/webp/logo-fast-blue-black_IMT.svg"
                  data-rjs="/assets/img/webp/logo-fast-blue-black@2x_IMT.svg"
                  alt="logo"
                />
                <img
                  className="alt-logo"
                  width="111"
                  height="108"
                  loading="lazy"
                  src="/assets/img/webp/logo-fast-blue-black_IMT.svg"
                  data-rjs="/assets/img/webp/logo-fast-blue-black@2x_IMT.svg"
                  alt="logo"
                />
                <img
                  className="mobile-logo"
                  width="111"
                  height="108"
                  loading="lazy"
                  src="/assets/img/webp/logo-fast-blue-black_IMT.svg"
                  data-rjs="/assets/img/webp/logo-fast-blue-black@2x_IMT.svg"
                  alt="logo"
                />
              </Navbar.Brand>
            </Link>
          </Col>
          {/* <Navbar.Toggle className="order-last md:mx-[15px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle> */}

          <Navbar.Collapse className="h-[80px] col-auto justify-end p-0">
            <div
              className="default-button"
              onClick={() => handleScroll("homepage")}
            >
              Homepage
            </div>
            <div
              className="default-button relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <span className="flex items-center">
                Services &amp; Products
                <svg
                  className="nav-caret"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
              <div
                className="dropdown absolute top-[100%] left-0 w-[260px] bg-white"
                id="service-product-menu"
              >
                <div
                  className="dropdown-item"
                  onClick={() => {
                    handleClickService("traffic-control");
                  }}
                >
                  Intelligent Traffic System (ITS)
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => {
                    handleClickService("surveillance");
                  }}
                >
                  Surveillance
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => {
                    handleClickService("medical-imaging");
                  }}
                >
                  Medical Imaging
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => {
                    handleClickService("san-storage");
                  }}
                >
                  San Storage
                </div>
              </div>
            </div>
            <div
              className="default-button nav-cta"
              onClick={() => handleScroll("contact")}
            >
              Contact Us
            </div>
            {/* <Menu {...props}/> */}
          </Navbar.Collapse>
          {/* <Col className="col-auto text-right !pr-0 pl-[15px] md:pl-0 md:pr-[15px] sm:pr-0"> */}
          {/*<SearchBar className="pl-[17px] xs:px-[15px]" />
            <HeaderLanguage className="pl-[17px] xs:pl-0 xs:pr-0" />*/}
          {/* </Col> */}
        </HeaderNav>
        <div className="hidden md:block">
          <button
            aria-label="Toggle menu"
            className="mobile-nav-toggle"
            onClick={toggleMenu}
          >
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {menuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              )}
            </svg>
          </button>

          {menuOpen && (
            <>
              <div className="mobile-nav-overlay" onClick={toggleMenu}></div>
              <div className="mobile-nav-menu">
                <div
                  className="mobile-nav-item"
                  onClick={() => handleMobileNav("homepage")}
                >
                  Homepage
                </div>
                <div
                  className="mobile-nav-item"
                  onClick={() => handleMobileNav("products")}
                >
                  Services &amp; Products
                </div>
                <div
                  className="mobile-nav-item"
                  onClick={() => handleMobileNav("contact")}
                >
                  Contact Us
                </div>
              </div>
            </>
          )}
        </div>
      </Header>

      {/* Header End */}
      {/* Section Introduction Start */}
      <section className="full-screen md:h-[600px] sm:h-[500px]" id="homepage">
        <SwiperSlide
          style={{ backgroundImage: `url(${HomeBusinessPageData.img})` }}
          className="bg-no-repeat	bg-cover	overflow-hidden relative bg-center"
        >
          <div className="absolute h-full w-full top-0 left-0 bg-gradient-dark-slate-blue"></div>
          <Container className="h-full relative">
            <Row className="h-full items-center">
              <Col
                xl={7}
                lg={9}
                sm={11}
                xs={12}
                className="text-white font-serif flex flex-col justify-center"
              >
                <span
                  className="uppercase font-medium inline-block"
                  style={{
                    letterSpacing: "3px",
                    fontSize: "13px",
                    opacity: 0.85,
                    marginBottom: "20px",
                  }}
                >
                  Smart City Technology Solutions
                </span>
                <h1
                  className="font-semibold"
                  style={{
                    fontSize: "clamp(2.2rem, 5vw, 4rem)",
                    lineHeight: 1.1,
                    letterSpacing: "-1px",
                    marginBottom: "25px",
                  }}
                >
                  {HomeBusinessPageData.title}
                </h1>
                <p
                  className="font-light text-xmd mb-[40px]"
                  style={{ textAlign: "justify", maxWidth: "620px", opacity: 0.8 }}
                >
                  {HomeBusinessPageData.content}
                </p>
                <div className="flex">
                  <div
                    onClick={() => handleScroll("services")}
                    className="cursor-pointer inline-flex items-center transition-all duration-300"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right,#71bdea 0,#775ea5 100%)",
                      color: "#fff",
                      padding: "14px 34px",
                      borderRadius: "6px",
                      fontWeight: 600,
                      letterSpacing: "0.5px",
                      boxShadow: "0 10px 30px rgba(119,94,165,0.35)",
                    }}
                  >
                    Explore Our Solutions
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </SwiperSlide>
      </section>
      {/* Section Introduction End*/}

      {/*Section Service */}
      <SectionHeading
        id="services"
        title="Services"
        subtitle="Comprehensive expertise across the full project lifecycle"
      />
      <section className="relative overflow-hidden" style={{ minHeight: "600px" }}>
        <div className="absolute h-full w-full top-0 left-0 bg-gradient-dark-slate-blue md:bg-black"></div>
        <Container className="relative py-[100px] lg:py-[90px] md:py-[75px] sm:py-[50px]">
          <Row className="items-center">
            <Col
              lg={6}
              md={12}
              className="text-white font-serif mb-0 md:mb-[40px]"
            >
              <div
                className="font-semibold"
                style={{ fontSize: "30px", lineHeight: 1.3, marginBottom: "25px" }}
              >
                {ServiceData.title.toUpperCase()}
              </div>
              <p
                className="text-white"
                style={{ textAlign: "justify", opacity: 0.9, marginBottom: "35px" }}
              >
                In our fields of expertise-security monitoring, intelligent
                transportation, and unified communications (UC) - we are not just
                specialists, but hands-on experts. Our expertise doesn’t come from
                a laboratory, but from real-world experience earned through years
                of designing, testing, optimizing, deploying, and operating some
                of the largest IT service systems across the country: national CDN
                networks, telecommunications infrastructure, video conferencing
                platforms, and backbone systems. Optimization, efficiency,
                creativity, and practicality are not just our guiding principles—they
                are the core values we bring to every project and the results we
                are committed to delivering for our clients. INMEETING provides
                comprehensive smart city solutions that cover every stage of a
                project lifecycle, including:
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  columnGap: "24px",
                  rowGap: "16px",
                }}
              >
                {ServiceLifecycle.map((item) => (
                  <div key={item} className="flex items-center text-white">
                    <span
                      className="flex items-center justify-center shrink-0"
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "9999px",
                        marginRight: "12px",
                        backgroundImage:
                          "linear-gradient(to right,#71bdea 0,#775ea5 100%)",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="3"
                        style={{ width: "13px", height: "13px" }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4.5 12.75l6 6 9-13.5"
                        />
                      </svg>
                    </span>
                    <span style={{ fontSize: "15px" }}>{item}</span>
                  </div>
                ))}
              </div>
            </Col>
            <Col lg={6} md={12} className="md:hidden">
              <img
                src={ServiceData.img}
                alt="Service"
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  objectFit: "cover",
                  boxShadow: "0 25px 55px rgba(0,0,0,0.45)",
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/*Section End*/}

      {/* Section Start Swiper */}
      {/* <section className="full-screen md:h-[600px] sm:h-[500px]">
        <Swiper
          className="slider-nav-dark white-move swiper-pagination-03 swiper-pagination-light swiper-pagination-large h-full"
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={0}
          loop={true}
          autoplay={{ delay: 4500, disableOnInteraction: false }}
          pagination={{ dynamicBullets: false, clickable: true }}
        >
          {
            SwiperData.map((item, i) => {
              return (
                <SwiperSlide key={i} style={{ backgroundImage: `url(${item.img})` }} className="bg-no-repeat	bg-cover	overflow-hidden relative bg-center">
                  <div className="absolute h-full w-full top-0 left-0 bg-gradient-dark-slate-blue"></div>
                  <Container className="h-full">
                    <Row className="h-full">
                      <Col xl={6} lg={7} sm={8} xs={12} className="h-full text-white font-serif justify-center flex-col relative flex">
                        <p className="mb-[40px] font-light text-xmd opacity-70 xs:mb-[20px] default-font-family" >{item.subtitle}</p>
                        <h2 className="mb-[55px] font-semibold xs:mb-[35px] default-font-family-bold">{item.title}</h2>
                      </Col>
                    </Row>
                  </Container>
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </section> */}
      {/* Section End */}

      {/* Section Start About Company */}
      {/* <section id="services" className="py-[160px] overflow-hidden lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
        <Container>
          <Row className="justify-center">
            <m.div className="col-xl-3 col-lg-4 col-sm-7 flex flex-col md:mb-24" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
              <div className="mb-[0px] md:text-center sm:mb-[0px]">
                <span className="font-serif text-md uppercase font-medium text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]">Dịch vụ Thiết kế giải pháp</span>
              </div>
              <h3 className="alt-font text-darkgray font-semibold mb-[20px] font-serif md:text-center md:mb-[0px] heading-5">Tối ưu nhất về chi phí và vận hành</h3>
              <div className="mt-auto mx-auto mx-lg-0">
               
              </div>
            </m.div>
            <Col xl={{ span: 8, offset: 1 }} lg={8}>
              <IconWithText grid="row-cols-1 row-cols-lg-1 row-cols-sm-1 gap-y-[0px]" theme="icon-with-text-01" data={IconWithTextData} animation={fadeIn} animationDelay={0.2} />
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* Section End */}

      {/* Products / Contact content (rendered eagerly so in-page anchors are always available) */}
      <>
        {/*Section Service */}
        <SectionHeading
          id="products"
          title="Products"
          subtitle="Trusted technologies powering our smart city solutions"
        />
        {/*Section End*/}
        {/* Section Start Porfolio*/}
        <m.section
          className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
          {...fadeIn}
        >
          <Container>
            <Tab01 activeKey={activeKey} data={TabData01} />
          </Container>
        </m.section>
        {/* Section End */}

        {/* Section Start Our premium service*/}
        {/*
        <section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] bg-[#f7f8fc]">
          <Container>
            <Row className="justify-center">
              <m.div className="col-xl-6 col-lg-7 col-sm-8 mb-20 text-center w-[51%] xl:mb-[70px] lg:mb-[65px] md:mb-[60px] sm:mb-[55px] md:w-[68%] xs:w-full" {...fadeIn}>
                <span className="inline-block font-serif text-md uppercase mb-[20px] font-medium  text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e] xs:mb-[15px]">our premium services</span>
                <h5 className="w-full mb-[20px] font-semibold text-darkgray font-serif -tracking-[1px]">Litho specializes in creativity design and innovative technology</h5>
              </m.div>
            </Row>
            <Row className="justify-center">
              <Col lg={12} md={9} xs={12}>
                <IconWithText grid="row-cols-1 row-cols-lg-2 gap-y-10 justify-center" theme="icon-with-text-02" data={IconWithTextData_02} animation={fadeIn} animationDelay={0.2} />
              </Col>
            </Row>
          </Container>
        </section>
        */}
        {/* Section End */}

        {/* Section Start Video Embedded */}

        {/*         <section
          className="py-[160px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px] relative bg-cover bg-center"
          style={{ backgroundImage: `url("https://via.placeholder.com/1920x1100")` }}
        >
          <div className="absolute top-0 left-0 w-full h-full opacity-60 bg-darkslateblue"></div>
          <Container className="relative">
            <Row className="justify-center text-center">
              <Col xl={7} lg={8} md={10}>
                <div className="font-serif text-white">

                  // Modal Component Start 
                  <CustomModal.Wrapper
                    modalBtn={
                      <m.span className="inline-block" {...{ ...zoomIn, transition: { type: "spring", stiffness: 200 } }}>
                        <Buttons ariaLabel="youtube video" type="submit" className="btn-sonar border-0 mx-auto mb-14" themeColor="#3452ff" color="#fff" size="lg" title={<i className="icon-control-play" />} />
                      </m.span>
                    }
                  >
                    <div className="w-[1020px] max-w-full relative rounded mx-auto">
                      <div className="fit-video">
                        <iframe width="100%" height="100%" className="shadow-[0_0_8px_rgba(0,0,0,0.06)]" controls src="https://www.youtube.com/embed/g0f_BRYJLJE?autoplay=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                      </div>
                    </div>
                  </CustomModal.Wrapper>
                  // Modal Component End

                  <m.h4 className="font-semibold mb-[45px]" {...{ ...fadeIn, transition: { delay: 0.2 } }}>Beautifully simple handcrafted templates for your website</m.h4>
                  <m.span className="uppercase tracking-[1px]" {...{ ...fadeIn, transition: { delay: 0.4 } }}>unlimited power and customization</m.span>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
 */}
        {/* Section End */}

        {/* Section Start Counter Data */}
        {/*
        <section className="py-[100px] lg:py-[90px] md:py-[75px]">
          <Container className="text-center">
            <Counter
              as="h4"
              theme="counter-style-02"
              grid="row-cols-1 row-cols-md-4 row-cols-sm-2 gap-y-10 items-center justify-center gap-y-10"
              className="text-black text-[70px]"
              data={CounterData}
              duration={2}
              animation={fadeIn}
            />
          </Container>
        </section>
        */}
        {/* Section End */}

        {/* Section Start Testimonials */}
        {/*}
        <section className="bg-[#f7f8fc] py-[130px] lg:py-[90px] md:py-[75px] sm:[50px]">
          <Container>
            <Row className="justify-center">
              <m.div className="col-xl-5 col-lg-6 col-sm-8 mb-20 text-center" {...fadeIn}>
                <span className="inline-block font-serif text-md uppercase mb-[20px] font-medium  text-gradient bg-gradient-to-r from-[#556fff] via-[#e355ff] to-[#ff798e]">What people are saying</span>
                <h3 className="w-full mb-[20px] font-semibold text-darkgray font-serif heading-5">What our valuable customer are saying about us?</h3>
              </m.div>
            </Row>
            <Row className='sm:justify-center sm:flex'>
              <Col md={12} sm={8}>
                <Testimonials
                  grid="row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-sm-8 gap-y-10 justify-center"
                  theme='testimonials-style-03'
                  data={TestimonialsData03}
                  animation={fadeIn}
                />
              </Col>
            </Row>
          </Container>
        </section>
         */}
        {/* Section End */}

        {/* Section Start animation */}
        {/*
        <section className="bg-[#f7f8fc] py-[100px] lg:py-[90px] md:py-[75px]">
          <Container>
            <Row className="justify-center">
              <Col lg={11}>
                <Clients grid="row-cols-2 row-cols-lg-6 row-cols-sm-3 md:gap-10 xs:gap-y-[50px] justify-between md:justify-center" theme="client-logo-style-05" data={ClientData} animation={fadeIn} />
              </Col>
            </Row>
          </Container>
        </section>
         */}
        {/* Section End */}

        {/* Section Start Get the latest insights */}
        {/*
        <section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]">
          <Container>
            <Row className="justify-center">
              <m.div className="col-xl-5 col-lg-6 col-sm-8 mb-16 text-center" {...fadeIn}>
                <span className="inline-block font-serif text-md uppercase mb-[20px] font-medium text-gradient bg-gradient-to-r from-[#556fff] via-[#e355ff] to-[#ff798e]">Get the latest insights</span>
                <h4 className="w-full mb-[20px] font-semibold text-darkgray font-serif heading-5">Stay updated with the latest trends and business news</h4>
              </m.div>
            </Row>
            <Row>
              <Col>
                <BlogClassic
                  pagination={false}
                  link="/blog-types/blog-standard-post/"
                  data={blogClassicdData}
                  grid="blog-wrapper grid grid-4col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-extra-large"
                />
              </Col>
            </Row>
          </Container>
        </section>
        */}
        {/* Section End */}

        {/* Footer Start */}
        <Footer className="bg-[#262b35] text-slateblue" theme="dark">
          <div className="py-[2%] lg:py-[2%] sm:py-[50px] ">
            <Container>
              <Row className="justify-end md:justify-center sm:justify-between md:flex-col">
                <Col
                  className="m-0 md:text-center sm:text-start"
                  lg={{ offSet: 0, span: 3, order: 0 }}
                  sm={{ span: 6, order: 5, offSet: 2 }}
                  md={{ span: 4, offset: 0, order: 5 }}
                  xs={{ span: 12, order: 5, offSet: 2 }}
                >
                  <Link
                    to="/"
                    className="text-slateblue mb-[15px] mt-[5px] inline-block"
                  >
                    <img
                      loading="lazy"
                      src="/assets/img/webp/logo-fast-blue-white_IMT.svg"
                      alt="logo"
                      width="160"
                      height="50"
                    />
                  </Link>
                  <p className="mb-[10px] text-slateblue sm:w-[90%] md:mb-[10px] md:text-center sm:text-start">
                    Email: info@inmeeting.com.vn
                  </p>
                  <p className="mb-[10px] text-slateblue sm:w-[90%] md:mb-[10px] md:text-center sm:text-start">
                    Địa chỉ: 07A Mạc Thị Bưởi, Vĩnh Tuy, Hà Nội
                  </p>
                  <p className="mt-[50px]">
                    © Copyright {new Date().getFullYear()}{" "}
                    <Link
                      to="/"
                      className="underline underline-offset-4 text-white font-normal"
                    >
                      {" "}
                      inMeeting JSC
                    </Link>
                  </p>
                </Col>
                {/*
                <FooterMenu data={FooterData.slice(0, 4)} lg={{ span: 2, offSet: 1, order: 0 }} md={{ span: 3, order: 0 }} sm={{ span: 4, offSet: 1, order: 2 }} className="xl:px-[15px] md:mb-[40px] xs:mb-[25px]" titleClass="capitalize" />
                */}
                <Col>
                  {/* <p className="mb-[10px] text-slateblue sm:w-[90%] md:mb-[10px] md:text-center sm:text-start text-justify"> Trong lĩnh vực của mình: giám sát an ninh, giao thông thông minh, truyền thông hợp nhất (UC), chúng tôi là chuyên gia. Chuyên gia không phải từ phòng lab, mà là kinh nghiệm thực chiến tích lũy qua quá trình thiết kế, thử nghiệm, tối ưu, triển khai, vận hành các hệ thống cung cấp dịch vụ IT lớn nhất trong toàn quốc: mạng CDN, viễn thông, video conference, backbone quốc gia,...Tối ưu, hiệu quả, sáng tạo, thực tế là tiêu chí của chúng tôi, và cũng là những gì chúng tôi cam kết mang lại cho dự án của khách hàng</p> */}
                  <section id="contact">
                    <Container>
                      <SectionHeading title="Contact Us" compact />
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "24px",
                          marginTop: "40px",
                        }}
                      >
                        {ContactData.map((c) => (
                          <div
                            key={c.title}
                            className="contact-card font-serif"
                            style={{ flex: "1 1 260px" }}
                          >
                            <span className="contact-card-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.7"
                                stroke="currentColor"
                                style={{ width: "26px", height: "26px" }}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d={c.icon}
                                />
                              </svg>
                            </span>
                            <p className="contact-card-title">{c.title}</p>
                            <p>
                              <a href={`mailto:${c.email}`}>{c.email}</a>
                            </p>
                            <p>{c.phone}</p>
                          </div>
                        ))}
                      </div>
                    </Container>
                  </section>
                </Col>
              </Row>
            </Container>
          </div>
        </Footer>
        {/* Footer End */}
      </>
    </div>
  );
};

export default HomeBusinessPage;
